module.exports = __webpack_public_path__ + "media/images/app/subscriptions/want-more-a0a062cefe5d6f3bae6ff42acecc7e7c.webp";